<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="isOpen"
      persistent
      max-width="1000px"
    >
      <v-card class="create-bridge-signing">
        <v-form>
          <v-card-title class="toolbar primary white--text">
            <v-icon dark>
              note_add
            </v-icon>
            <h3
              class="title ml-2"
            >
              Calculate Tranche Utilization
            </h3>
            <v-spacer />
            <v-btn
              color="secondary"
              flat
              @click="onToggleOpen"
            >
              X
            </v-btn>
          </v-card-title>
          <v-progress-linear
            v-if="isLoading"
            :indeterminate="true"
            class="ma-0"
          />

          <v-card-text>
            This will trigger the tranche utilization manually for the following Tranche ID:
            {{ trancheUtilization.trancheId }}
            <v-spacer />

            <div v-if="calculationResult">
              Used Pieces: {{ calculationResult.totalReservedAndInvestedPieces }}
            </div>
            <div v-else>
              Calculate first!
            </div>
            <v-alert
              v-for="e in error"
              :key="e.path"
              :value="error"
              type="error"
              color="error"
            >
              {{ e.message }}
            </v-alert>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn
              color="secondary"
              flat
              @click="onToggleOpen"
            >
              Cancel
            </v-btn>
            <v-tooltip
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  :disabled="isLoading"
                  :loading="isLoading"
                  color="primary"
                  @click="showUtilization"
                  v-on="on"
                >
                  <span>Show Tranche-Utilization</span>
                </v-btn>
              </template>
              <span>Only show the Utilization</span>
            </v-tooltip>
            <v-tooltip
              v-if="calculationResult"
              top
              dark
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  class="ml-3"
                  :disabled="isLoading"
                  :loading="isLoading"
                  color="error"
                  @click="setUtilization"
                  v-on="on"
                >
                  <span>Set Tranche-Utilization</span>
                </v-btn>
              </template>
              <span>Set the Utilization</span>
            </v-tooltip>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
export default {
  name: 'CalculateTrancheUtilizationDialog',
  props: {
    trancheUtilization: {
      type: Object,
      required: true,
    },
    isOpen: {
      type: Boolean,
      required: true,
    },
    toggleOpen: {
      type: Function,
      required: true,
    },
  },
  data: () => ({
    calculationResult: null,
    isOpenProp: this.isOpen,
    isLoading: false,
    error: null,
  }),
  mounted() {
    this.calculationResult = null;
  },
  methods: {
    onToggleOpen() {
      this.toggleOpen();
      this.error = null;
    },
    showUtilization() {
      this.isLoading = true;

      this.$store
        .dispatch('calculateStrategiesTrancheUtilizationByTrancheIdManually', {
          trancheId: this.trancheUtilization.trancheId,
        })
        .then((data) => {
          this.calculationResult = data;
        })
        .catch((err) => {
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    setUtilization() {
      this.isLoading = true;

      this.$store
        .dispatch('calculateStrategiesTrancheUtilizationByTrancheIdManually', {
          trancheId: this.trancheUtilization.trancheId,
          update: true,
        })
        .then((data) => {
          this.calculationResult = data;
        })
        .catch((err) => {
          this.error = err;
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
  },
};
</script>

<style lang="scss">
  .create-bridge-signing {
    .v-card__title {
      padding: 24px;
    }

    .v-card__text {
      max-height: 65vh;
      overflow: auto;
      padding-top: 32px;
    }

    .v-card__actions {
      border-top: 1px solid rgba(0, 0, 0, 0.12);
    }

    .subheading {
      padding: 8px;
      background: white;
      color: rgba(0, 0, 0, 0.54);
      top: -20px;
      left: 8px;
      position: absolute;
      display: flex;
      align-items: center;
    }

    .container.grid-list-md .layout:not(:only-child) {
      margin: 0 0 24px 0;
    }

    .v-input--selection-controls.v-input .v-label {
      text-transform: capitalize;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/settlements/dialog/CalculateTrancheUtilizationDialog.vue